import {EVENT, LOADING,} from "./getter_types";

export default {

    [EVENT]: state => state.eventManagement.event,
    [LOADING]: state => state.loading,
};
